import { APP_VERSION } from 'constants/app';
import { useState, useCallback } from 'react';
import { AnalyticsApplication } from '@landr/core';
import useMountEffect from 'hooks/useMountEffect';
import { log } from 'utils/log';
import { User as ApiUser } from 'types/generated/graphql';
import { auth } from 'utils/auth';
import {
    DefaultLanguage,
    Languages,
    User,
    NavbarConfig,
} from './LandrNavbar/LandrNavbar';

const ApiLanguages: any = {
    [Languages.English]: 'en',
    [Languages.French]: 'fr',
};

export const useUniversalNavBarConfig = ({
    userProfile,
    locale,
}: {
    userProfile: ApiUser | undefined;
    locale: string;
}) => {
    const [navBarConfig, setNavBarConfig] = useState<NavbarConfig>();

    useMountEffect(() => {
        const defineNavBarConfig = async () => {
            const token = await auth.getAccessToken();

            setNavBarConfig({
                isLocal: false,
                authorizationToken: token,
                applicationName: AnalyticsApplication.Samples,
                applicationVersion: APP_VERSION,
                log,
            });
        };

        defineNavBarConfig();
    });

    const language = ApiLanguages[locale] || DefaultLanguage;
    const user = (userProfile as User) || null;

    return { navBarConfig, language, user };
};

export const useUniversalNavBarHandlers = (
    login: () => void,
    signup: () => void,
) => {
    const handleLogin = useCallback((isSignup = false) => {
        if (isSignup) {
            signup();
        } else {
            login();
        }
    }, []);

    return handleLogin;
};
